import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';
import { api } from '../../../services/api.js';
import { FaStar } from 'react-icons/fa';
import './AvaliacaoPopup.css';

const AvaliacaoPopup = ({ usuario, datault, codigoRestaurante, nomeRestaurante, onClose }) => {
  const [nota, setNota] = useState(null);
  const [comentario, setComentario] = useState('');
  const [hovered, setHovered] = useState(null);

  const handleSubmit = async () => {
    if (!nota) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Você deve escolher uma nota.',
        confirmButtonColor: '#8b0000'
      });
      return;
    }
    if (nota <= 2 && comentario.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Comentário obrigatório para notas até 2.',
        confirmButtonColor: '#8b0000'
      });
      return;
    }

    const payload = {
      codigo: codigoRestaurante || '0',
      avaliacao: nota,
      comentario,
      data: datault
    };

    try {
      const res = await api.post(`/restaurante/${usuario}/avaliar`, payload);
      if (res.status === 201) {
        Swal.fire({
          icon: 'success',
          title: 'Obrigado!',
          text: 'Sua avaliação foi registrada.',
          confirmButtonColor: '#8b0000'
        });
        onClose();
      } else {
        const msg = res.data?.mensagem || 'Erro ao registrar avaliação';
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: msg,
          confirmButtonColor: '#8b0000'
        });
      }
    } catch (err) {
      let msg = 'Falha ao acessar o servidor';
      if (err.response?.data?.erro) {
        msg = Array.isArray(err.response.data.erro) ? err.response.data.erro[0] : err.response.data.erro;
      }
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: msg,
        confirmButtonColor: '#8b0000'
      });
    }
  };

  return (
    <Modal show centered backdrop="static" keyboard={false} className="rounded-4 overflow-hidden">
      <Modal.Header className="bg-danger text-white border-0 p-3 p-md-4" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)' }}>
        <Modal.Title className="w-100 text-center fw-bold fs-5 text-white d-flex align-items-center justify-content-center gap-2">
          <FaStar /> Avalie sua última refeição
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center p-4">
        <div className="badge bg-light text-secondary border px-3 py-1.5 mb-2 extra-small fw-semibold">
          Data: {datault}
        </div>

        <h6 className="fw-bold text-dark text-uppercase my-2">
          {codigoRestaurante} - {nomeRestaurante}
        </h6>

        <div className="d-flex justify-content-center my-3">
          {[1, 2, 3, 4, 5].map((n) => (
            <FontAwesomeIcon
              key={n}
              icon={(nota >= n || hovered >= n) ? solidStar : regularStar}
              className="star"
              onMouseEnter={() => setHovered(n)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => setNota(n)}
            />
          ))}
        </div>

        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Deixe um comentário sobre a comida ou atendimento..."
          value={comentario}
          onChange={(e) => setComentario(e.target.value)}
          className="form-control-sm my-3"
        />
      </Modal.Body>

      <Modal.Footer className="border-top bg-light p-3 d-flex justify-content-center">
        <Button 
          className="px-5 fw-bold rounded-3 border-0 py-2 text-white" 
          style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
          onClick={handleSubmit}
        >
          Confirmar Avaliação
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AvaliacaoPopup;